/* Type of article file for upload */
export enum ImportFileExtension {
	Dxf = 0,
	Step = 1,
}
